"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendOptions = void 0;
const i18next_localstorage_backend_1 = __importDefault(require("i18next-localstorage-backend")); // primary use cache
const i18next_http_backend_1 = __importDefault(require("i18next-http-backend")); // fallback http load
// eslint-disable-next-line import/prefer-default-export
const backendOptions = (bucketBase, productName) => ({
    backends: [
        // Cache Translations : https://github.com/i18next/i18next-localstorage-backend
        i18next_localstorage_backend_1.default,
        // Load through HTTP
        i18next_http_backend_1.default,
    ],
    backendOptions: [
        // LocalStorageBackend options
        {
            prefix: 'i18next_res_',
            expirationTime: 7 * 24 * 60 * 60 * 1000,
            defaultVersion: 'v1.0',
            versions: {},
            store: typeof window !== 'undefined' ? window.localStorage : null, // can be either window.localStorage or window.sessionStorage. Default: window.localStorage
        },
        // HttpApi Options
        {
            allowMultiLoading: false,
            // Load product translations
            loadPath: `${bucketBase}/${encodeURI(productName)}/i18n/{{lng}}/{{ns}}.json`,
        },
    ],
});
exports.backendOptions = backendOptions;
